import { cloneDeep } from "lodash-es";
import type { PiniaPluginContext } from "pinia";

export function autoResetPlugin({ store, options }: PiniaPluginContext) {
  // option stores already provide $reset; only setup stores opting in need one
  if (typeof options.state !== "function" && options.autoReset) {
    const initial = cloneDeep(store.$state);
    // Replace each top-level state property. $patch merges, so record state
    // would keep entries. The mutator form assigns wholesale and thus fully resets.
    store.$reset = () =>
      store.$patch((state) => {
        Object.assign(state, cloneDeep(initial));
      });
  }
}
